<template>
  <div
    data-scrollbar="true"
    data-height="100%"
    data-skip-mobile="true"
    class="pos-content-container"
  >
    <slot></slot>
  </div>
</template>

<script>
import { TabEventBus } from './EventBus'

export default {
  name: 'TabPanesHorizontal',
  props: {
    name: { type: String, required: true },
    elProp: { type: Object }
  },
  provide () {
    return {
      elProp: this.elProp
    }
  },
  mounted () {
    if (this.$children.length > 0) {
      this.$children[0].isShow = true
    }
    TabEventBus.$on('tabchange', activeTab => {
      if (this.name !== activeTab.target) return
      this.$children
        .filter(child => child !== this.$children[activeTab.index])
        .forEach(child => (child.isShow = false))
      if (this.$children[activeTab.index]) {
        this.$children[activeTab.index].isShow = true
      }
    })
  },
  watch: {
    'elProp.activeTab': {
      handler (selectedTab) {
        this.deactiveOtherTabs(selectedTab)
        TabEventBus.$emit('tabchange', {
          target: this.target,
          index: this.$children.indexOf(selectedTab)
        })
      }
    }
  }
}
</script>
